import { createTheme } from '@mui/material/styles';
// import table from './table';
import autocomplete from './autocomplete';
import baseTheme from './base';
import button from './button';
import datePicker from './datePicker';
import form from './form';
import input from './input';

const theme = createTheme(baseTheme, {
  components: {
    // ...layout(base),
    ...input,
    // ...select,
    ...button,
    ...autocomplete,
    // ...list,
    ...form,
    // ...table,
    // ...menu,
    // ...alerts,
    // ...tabs,
    // ...toggles,
    // ...dialog,
    // ...pagination,
    // ...tooltip,
    // ...datagrid,
    // ...loader,
    // ...accordion,
    // ...link,
    ...datePicker,
  },
});

export default theme;
